module.exports = __webpack_public_path__ + "static/media/clubs_K.7ac668b5.png";